import { useState, useEffect } from "react";
import { useUserAuth } from "../../context/UserAuthContext";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const InvoiceBasic = () => {
  const { user, token } = useUserAuth();
  const merchant_id = user?.uid;
  const navigate = useNavigate();
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  const [data, setData] = useState({
    business_name: "",
    address: "",
    gst: "",
    bank_name: "",
    branch_name: "",
    ifsc_code: "",
    ac_no: "",
    upi: "",
    mob_no: "",
  });
  console.log(data)
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!merchant_id) return;

    const getUserData = async () => {
      try {
        const res = await axios.get(`${base_url}/api/v1/invoice-basics/${merchant_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }

        );
        // console.log('fetched basic invoice info',res.data.data)
        if (res?.data?.data) {
          setData(res.data.data);
        }
      } catch (error) {
        console.error(`Error fetching data: ${error.message}`);
        toast.error("Failed to fetch data");
      }
    };

    getUserData();
  }, [merchant_id]);

  const formHandler = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const btnHandler = async (e) => {
    e.preventDefault();

    const {
      business_name,
      address,
      gst,
      bank_name,
      branch_name,
      ifsc_code,
      ac_no,
      upi,
      mob_no,
    } = data;

    // Validate form
    if (
      !business_name ||
      !address ||
      !bank_name ||
      !branch_name ||
      !ifsc_code ||
      !ac_no ||
      !upi ||
      !mob_no
    ) {
      toast.error("All fields are required");
      return;
    }

    // if (!/^\d{10}$/.test(mob_no)) {
    //   toast.error("Enter a valid 10-digit mobile number");
    //   return;
    // }

    const form_data = {
      user_id: merchant_id,
      business_name,
      address,
      gst,
      bank_name,
      branch_name,
      ifsc_code,
      ac_no,
      upi,
      mob_no,
    };

    setIsSubmitting(true);
    try {
      const res = await axios.post(`${base_url}/api/v1/invoice-basics/add-invoice-basics`,
        form_data, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
      );
      toast.success("Details added successfully");
      // navigate("/dashboard/dash_board");
    } catch (err) {
      console.error(`Error submitting form: ${err.message}`);
      toast.error("Failed to submit details");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#085f9a" }}
              >
                Invoice Basic
              </div>
              <div className="card-body">
                <form onSubmit={btnHandler}>
                  <div className="row">
                    <div className="form-group col-md-4">
                      <label>Business Name</label>
                      <input
                        type="text"
                        name="business_name"
                        placeholder="Enter Business Name"
                        value={data.business_name}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label>Business Address</label>
                      <input
                        type="text"
                        name="address"
                        placeholder="Enter Business Address"
                        value={data.address}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label>GST Number</label>
                      <input
                        type="text"
                        name="gst"
                        placeholder="Enter GST Number"
                        value={data.gst}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-4">
                      <label>Mobile Number</label>
                      <input
                        type="tel"
                        name="mob_no"
                        placeholder="Enter Mobile Number"
                        value={data.mob_no}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label>Bank Name</label>
                      <input
                        type="text"
                        name="bank_name"
                        placeholder="Enter Bank Name"
                        value={data.bank_name}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label>Branch Name</label>
                      <input
                        type="text"
                        name="branch_name"
                        placeholder="Enter Branch Name"
                        value={data.branch_name}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-4">
                      <label>IFSC Code</label>
                      <input
                        type="text"
                        name="ifsc_code"
                        placeholder="Enter IFSC Code"
                        value={data.ifsc_code}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label>Account Number</label>
                      <input
                        type="text"
                        name="ac_no"
                        placeholder="Enter Account Number"
                        value={data.ac_no}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-4">
                      <label>UPI</label>
                      <input
                        type="text"
                        name="upi"
                        placeholder="Enter UPI ID"
                        value={data.upi}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn my-bg text-white"
                    >
                      {isSubmitting ? "Updating..." : "Update"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InvoiceBasic;